import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_whatsapp.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_more.svg'
import _imports_2 from '@/app/ui/assets/svg/ics_o_ubah_tagihan.svg'
import _imports_3 from '@/app/ui/assets/svg/ics_o_update_lunas.svg'
import _imports_4 from '@/app/ui/assets/svg/ics_o_kirim_tagihan.svg'
import _imports_5 from '@/app/ui/assets/svg/ics_o_download_pdf.svg'
import _imports_6 from '@/app/ui/assets/svg/ics_o_download_png.svg'
import _imports_7 from '@/app/ui/assets/svg/ics_o_download_pdf_struk.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-6637bb03")

_pushScopeId("data-v-6637bb03")
const _hoisted_1 = { class: "h-screen bg-white px-4" }
const _hoisted_2 = { class: "flex items-center justify-between py-3 px-6 border-b border-gray-lp-2100" }
const _hoisted_3 = { class: "text-gray-lp-300 text-xl font-semibold" }
const _hoisted_4 = { class: "flex justify-between gap-x-4 py-4" }
const _hoisted_5 = {
  key: 0,
  class: "h-4/5 flex flex-col items-center justify-center"
}
const _hoisted_6 = { class: "flex flex-col text-sm text-gray-lp-800 text-center gap-y-2" }
const _hoisted_7 = { class: "flex flex-col gap-1" }
const _hoisted_8 = { class: "flex items-center gap-2 text-xs text-gray-400" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  class: "ml-1",
  src: _imports_0,
  alt: "wa-icon"
}, null, -1)
const _hoisted_10 = { class: "flex flex-col gap-y-2 text-sm" }
const _hoisted_11 = { class: "flex items-center gap-x-2" }
const _hoisted_12 = { class: "flex items-center gap-x-2" }
const _hoisted_13 = { class: "text-black-lp-300" }
const _hoisted_14 = { class: "capitalize text-gray-lp-500" }
const _hoisted_15 = { class: "text-black-lp-300" }
const _hoisted_16 = { class: "capitalize text-gray-lp-500" }
const _hoisted_17 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "more_button"
}, null, -1)
const _hoisted_18 = { class: "flex flex-col" }
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-6 h-6",
  alt: "detail"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "w-6 h-6",
  alt: "detail"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  class: "w-6 h-6",
  alt: "detail"
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("img", {
  src: _imports_5,
  class: "w-6 h-6",
  alt: "detail"
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("img", {
  src: _imports_6,
  class: "w-6 h-6",
  alt: "detail"
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("img", {
  src: _imports_7,
  class: "w-6 h-6",
  alt: "detail"
}, null, -1)
const _hoisted_25 = { class: "p-8 font-montserrat" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Search = _resolveComponent("Search")!
  const _component_time_range_picker = _resolveComponent("time-range-picker")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_TableTagihan = _resolveComponent("TableTagihan")!
  const _component_ModalSendInvoice = _resolveComponent("ModalSendInvoice")!
  const _component_ModalSuccessSendInvoice = _resolveComponent("ModalSuccessSendInvoice")!
  const _component_ModalUpdateInvoice = _resolveComponent("ModalUpdateInvoice")!
  const _component_InvoicePdfStruk = _resolveComponent("InvoicePdfStruk")!
  const _component_InvoicePdfA4 = _resolveComponent("InvoicePdfA4")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("section", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("tagihan.pageTitle")), 1),
        _createVNode(_component_LpButton, {
          iconLeft: "ics_f_plus_circle",
          sizeIcon: "w-5",
          textColor: "white",
          title: _ctx.$t('tagihan.createTitle'),
          onClick: _ctx.goToCreateReceipt
        }, null, 8, ["title", "onClick"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_Search, {
          onInput: _ctx.onSearch,
          onClear: _ctx.onClear,
          value: _ctx.params.search,
          placeholder: _ctx.$t('tagihan.searchPlaceholder'),
          class: "w-full"
        }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
        _createVNode(_component_time_range_picker, {
          default: "custom",
          startDate: _ctx.params.dateFrom,
          endDate: _ctx.params.dateTo,
          maxDate: new Date(),
          onSelect: _ctx.setDateRange,
          class: "w-full",
          showOptions: 
          `${_ctx.$t('custom')}, ${_ctx.$t('hari ini')}, ${_ctx.$t('7 hari terakhir')}, ${_ctx.$t(
            '14 hari terakhir'
          )}`
        ,
          isCloseDateAfterSelect: ""
        }, null, 8, ["startDate", "endDate", "maxDate", "onSelect", "showOptions"]),
        _createVNode(_component_SelectSearch, {
          options: _ctx.statusOptionList,
          keyName: "name",
          keyValue: "value",
          placeholder: _ctx.$t('tagihan.selectStatus'),
          modelValue: _ctx.statusSelected,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.statusSelected = $event)),
          class: "w-full h-5",
          onChange: _ctx.onSelectStatus
        }, null, 8, ["options", "placeholder", "modelValue", "onChange"])
      ]),
      (!_ctx.invoicesData.data.length && !_ctx.isLoading && !_ctx.errorCause)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode("img", {
              src: require('@/app/ui/assets/svg/ill_spot_miscellaneous.svg'),
              alt: "ill_spot_miscellaneous"
            }, null, 8, ["src"]),
            _createVNode("div", _hoisted_6, [
              _createVNode("b", null, _toDisplayString(_ctx.$t("tagihan.emptyTitle")), 1),
              _createVNode("span", null, _toDisplayString(_ctx.$t("tagihan.emptyDescription")), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.errorCause && !_ctx.invoicesData.data.length && !_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_ErrorMessage, {
            key: 1,
            errorType: _ctx.errorCause,
            onTryAgain: _ctx.fetchListInvoices
          }, null, 8, ["errorType", "onTryAgain"]))
        : _createCommentVNode("", true),
      (_ctx.invoicesData.data.length && !_ctx.errorCause)
        ? (_openBlock(), _createBlock(_component_TableTagihan, {
            key: 2,
            column: _ctx.column,
            tableData: _ctx.invoicesData.data,
            loading: _ctx.isLoading,
            pagination: _ctx.invoicesData.pagination,
            page: _ctx.params.page,
            "onUpdate:page": _cache[2] || (_cache[2] = ($event: any) => (_ctx.params.page = $event)),
            onRequest: _ctx.fetchListInvoices,
            substractHeight: "275"
          }, {
            billedTo: _withId(({ data }) => [
              _createVNode("div", _hoisted_7, [
                _createVNode("span", {
                  title: data.billedToName,
                  class: "font-medium text-gray-900 two-line",
                  style: {"width":"200px"}
                }, _toDisplayString(data.billedToName), 9, ["title"]),
                _createVNode("a", {
                  target: "_blank",
                  href: `https://wa.me/${_ctx.formatPhoneForWa(data.billedToPhone)}`
                }, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("span", null, _toDisplayString(_ctx.maskSensitiveData(data.billedToPhone)), 1),
                    _hoisted_9
                  ])
                ], 8, ["href"])
              ])
            ]),
            status: _withId(({ data }) => [
              _createVNode("span", {
                class: ["inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold", _ctx.getStatusBadge(data.status).class]
              }, [
                (data.status !== 'Semua')
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: _ctx.getStatusBadge(data.status).icon,
                      class: "w-4 h-4 mr-0.5",
                      alt: "status-icon"
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.getStatusBadge(data.status).label), 1)
              ], 2)
            ]),
            activities: _withId(({ data }) => [
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, [
                  _createVNode("img", {
                    src: _ctx.getActivityItem(data.isInvoicePrinted).icon,
                    class: "w-5 h-5",
                    alt: "print-status"
                  }, null, 8, ["src"]),
                  _createVNode("span", {
                    class: _ctx.getActivityItem(data.isInvoicePrinted).textClass
                  }, _toDisplayString(_ctx.$t("tagihan.activity.printInvoice")), 3)
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("img", {
                    src: _ctx.getActivityItem(data.isInvoiceSent).icon,
                    class: "w-5 h-5",
                    alt: "send-status"
                  }, null, 8, ["src"]),
                  _createVNode("span", {
                    class: _ctx.getActivityItem(data.isInvoiceSent).textClass
                  }, _toDisplayString(_ctx.$t("tagihan.activity.sendInvoice")), 3)
                ])
              ])
            ]),
            createdAt: _withId(({ data }) => [
              _createVNode("div", _hoisted_13, _toDisplayString(_ctx.formatDateWithTz(data.createdAt, "DD MMMM YYYY, HH:mm")), 1),
              _createVNode("div", _hoisted_14, _toDisplayString(_ctx.ellipsisString(data.createdByName || "-", 30)), 1)
            ]),
            updatedAt: _withId(({ data }) => [
              _createVNode("div", _hoisted_15, _toDisplayString(_ctx.formatDateWithTz(data.updatedAt, "DD MMMM YYYY, HH:mm")), 1),
              _createVNode("div", _hoisted_16, _toDisplayString(_ctx.ellipsisString(data.updatedByName || "-", 30)), 1)
            ]),
            action: _withId(({data, index}) => [
              _createVNode("button", {
                onClick: ($event: any) => (_ctx.toggleAction($event, index))
              }, [
                _hoisted_17
              ], 8, ["onClick"]),
              _createVNode(_component_OverlayPanel, {
                ref: (el) => _ctx.actionOPRefs[index] = el,
                class: "rounded-md",
                style: {"width":"312px"}
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_18, [
                    (data.status === 'unpaid')
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: "#",
                          class: "flex flex-row gap-2 items-center text-left py-3 px-3 text-sm text-gray-lp-300 font-medium border-b border-gray-lp-400 hover:bg-gray-50 transition-colors",
                          onClick: () => _ctx.goToEditReceipt(data.id)
                        }, {
                          default: _withId(() => [
                            _hoisted_19,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("tagihan.action.editInvoice")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (
                data.status === 'unpaid' || data.status === 'partially_paid'
              )
                      ? (_openBlock(), _createBlock("div", {
                          key: 1,
                          class: "flex flex-row gap-2 items-center text-left py-3 px-3 text-sm text-gray-lp-300 font-medium border-b border-gray-lp-400 cursor-pointer hover:bg-gray-50 transition-colors",
                          onClick: ($event: any) => (_ctx.onShowModalUpdateInvoice(data, $event, index))
                        }, [
                          _hoisted_20,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("tagihan.action.updatePaid")), 1)
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode("div", {
                      to: "#",
                      class: "flex flex-row gap-2 items-center text-left py-3 px-3 text-sm text-gray-lp-300 font-medium border-b border-gray-lp-400 cursor-pointer hover:bg-gray-50 transition-colors",
                      onClick: ($event: any) => (_ctx.onShowModalSendInvoice(data, $event, index))
                    }, [
                      _hoisted_21,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("tagihan.action.sendInvoice")), 1)
                    ], 8, ["onClick"]),
                    _createVNode("button", {
                      class: "flex flex-row gap-2 items-center text-left py-3 px-3 text-sm text-gray-lp-300 font-medium border-b border-gray-lp-400 hover:bg-gray-50 transition-colors",
                      onClick: ($event: any) => (_ctx.download($event, index, 'pdf-a4', data.id))
                    }, [
                      _hoisted_22,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("tagihan.action.downloadPdfA4")), 1)
                    ], 8, ["onClick"]),
                    _createVNode("button", {
                      to: "#",
                      class: "flex flex-row gap-2 items-center text-left py-3 px-3 text-sm text-gray-lp-300 font-medium border-b border-gray-lp-400 hover:bg-gray-50 transition-colors",
                      onClick: ($event: any) => (_ctx.download($event, index, 'png', data.id))
                    }, [
                      _hoisted_23,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("tagihan.action.downloadPngA4")), 1)
                    ], 8, ["onClick"]),
                    _createVNode("button", {
                      to: "#",
                      class: "flex flex-row gap-2 items-center text-left py-3 px-3 text-sm text-gray-lp-300 font-medium border-b border-gray-lp-400 hover:bg-gray-50 transition-colors",
                      onClick: ($event: any) => (_ctx.download($event, index, 'pdf-struk', data.id))
                    }, [
                      _hoisted_24,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("tagihan.action.downloadPdfStruk")), 1)
                    ], 8, ["onClick"])
                  ])
                ]),
                _: 2
              }, 1536)
            ]),
            _: 1
          }, 8, ["column", "tableData", "loading", "pagination", "page", "onRequest"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ModalSendInvoice, {
      show: _ctx.showSendModal,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (_ctx.showSendModal = $event)),
      invoiceData: _ctx.invoiceDataProps,
      onSuccess: _ctx.onSendSuccess
    }, null, 8, ["show", "invoiceData", "onSuccess"]),
    _createVNode(_component_ModalSuccessSendInvoice),
    _createVNode("div", _hoisted_25, [
      (_ctx.showModalUpdateInvoice)
        ? (_openBlock(), _createBlock(_component_ModalUpdateInvoice, {
            key: 0,
            invoiceData: _ctx.currentData,
            onClose: _ctx.closeModal,
            onSuccess: _ctx.handleSuccess
          }, null, 8, ["invoiceData", "onClose", "onSuccess"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_InvoicePdfStruk, {
      ref: "struk",
      invoiceData: _ctx.invoiceData.header,
      items: _ctx.invoiceData.items
    }, null, 8, ["invoiceData", "items"]),
    _createVNode(_component_InvoicePdfA4, {
      ref: "invoice",
      invoiceData: _ctx.invoiceData.header,
      items: _ctx.invoiceData.items
    }, null, 8, ["invoiceData", "items"])
  ], 64))
})